import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { FaUndo } from 'react-icons/fa';

import intlShape from '@/shared/utils/intlShape';
import RelationSearch from '@/shared/components/input/RelationSearch';
import { CapacityTaskSelect } from '@/shared/components/input/filterInputs/FilterCapacityTaskSelect';

import messages from './deviationOverviewMessages';

export const defaultFilters = {
  relationId: null,
  relationName: null,
  mainTaskTemplateId: undefined,
};

class DeviationOverviewFilters extends PureComponent {
  static propTypes = {
    onFilterChange: PropTypes.func.isRequired,
    filters: PropTypes.shape({
      relationId: PropTypes.string,
      relationName: PropTypes.string,
      mainTaskTemplateId: PropTypes.string,
    }),
    onResetFilters: PropTypes.func.isRequired,
    hasFilters: PropTypes.bool,
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    filters: defaultFilters,
    hasFilters: false,
  };

  filterChanged = filter => {
    const { filters, onFilterChange } = this.props;
    const newFilters = { ...filters, ...filter };
    if (filters !== newFilters) onFilterChange(newFilters);
  };

  relationChanged = item => {
    if (!item || !item.id) {
      this.filterChanged({ relationId: null, relationName: null });
    } else {
      this.filterChanged({
        relationId: item.key,
        relationName: item.label,
      });
    }
  };

  mainTaskChanged = value => {
    this.filterChanged({ mainTaskTemplateId: value || undefined });
  };

  render() {
    const { filters, intl, onResetFilters, hasFilters } = this.props;

    const initRelation = filters.relationId
      ? { key: filters.relationId, label: filters.relationName }
      : null;

    return (
      <div className="info-block container-fluid radius4B">
        <div className="row">
          <div className="col-lg-4 col-sm-12 margin10B">
            <RelationSearch onChange={this.relationChanged} initialSelectedItem={initRelation} />
          </div>
          <div className="col-lg-4 col-sm-6 margin10B">
            <CapacityTaskSelect
              initialValue={filters.mainTaskTemplateId}
              onChange={this.mainTaskChanged}
              placeholder={intl.formatMessage(messages.AllMainTasks)}
            />
          </div>
        </div>
        {hasFilters && (
          <div className="row">
            <div className="col-sm-12">
              <button
                type="button"
                className="btn btn-default btn-reset"
                onClick={() => onResetFilters()}
              >
                <FaUndo className="react-icon" />
                &nbsp;
                <FormattedMessage {...messages.ResetFilters} />
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default injectIntl(DeviationOverviewFilters);
